import { useSearchParams } from 'react-router-dom';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@eo/shared';

import { selectionName, selectionSearch } from './helpers';
import { SelectionDetail } from './SelectionDetail';
import type { SelectionDialogProps } from './types';

// A client's or a person's detail opens over the page, so the reader never
// loses their place; the URL holds what is open, so a link reopens it.
export function SelectionDialog({
  data,
  selection,
  meId,
  onQueryOptions,
  onGenerateExcess,
}: SelectionDialogProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const close = () => setSearchParams(new URLSearchParams(selectionSearch(searchParams, null)));

  return (
    <Dialog open onOpenChange={(open) => (open ? undefined : close())}>
      {/* Only the body scrolls, so the close button stays in the corner. */}
      <DialogContent className="flex max-h-[85vh] flex-col sm:max-w-5xl">
        <DialogHeader className="pr-8">
          <DialogTitle>{selectionName(data.report, selection)}</DialogTitle>
          <DialogDescription>
            {selection.kind === 'client'
              ? 'Where this client’s month is heading, who worked on it, its time log, and its excess hours bill.'
              : 'This person’s capacity, how their month splits, their clients, and their time log.'}
          </DialogDescription>
        </DialogHeader>
        {/* The gutter keeps room for the vertical bar, and the padding room for
          focus rings, so nothing pushes the body sideways. */}
        <div className="-mx-1 min-h-0 min-w-0 overflow-x-hidden overflow-y-auto px-1 [scrollbar-gutter:stable]">
          <SelectionDetail
            data={data}
            selection={selection}
            meId={meId}
            onQueryOptions={onQueryOptions}
            onGenerateExcess={onGenerateExcess}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
